import { OPEN } from '../../constants/constant_transaction_status';

export const calculateQuantityAvailable = (item_location, settings) => {
  if (item_location) {
    const { include_backorder } = settings;
    const backOrderQty = include_backorder
      ? Number(item_location.back_order_quantity) || 0
      : 0;
    const inTransit = Number(item_location.in_transit) || 0;
    const onHand = Number(item_location.on_hand) || 0;

    return onHand + backOrderQty - inTransit;
  }
  return 0;
};


export const setLineItemId = (result, statusCid = OPEN) => {
  if (result.status.cid === statusCid) {
    result.lines.forEach((line) => {
      if (line.item_uom) {
        line.item_id = `${line.item.id}:${line.item_uom.id}`;
        line.item.id = line.item_id;
      }
    });
  }
}
